import styles from "../ProductStatusBox.module.scss";

export type GalleryButtonProps = {
  handleImageClick: () => void;
  image: string;
  title: string;
};

export const GalleryButton = ({
  handleImageClick,
  image,
  title,
}: GalleryButtonProps) => {
  return (
    <button
      type="button"
      className={styles.mainImageButton}
      aria-label="main product image"
      data-testid="oos-layout:main-image:button"
      onClick={handleImageClick}
    >
      <img
        src={`${image}?$rsp-pdp-port-320$`}
        alt={title}
        className={styles.mainImage}
      />
    </button>
  );
};
